import { useEnv } from '@gemini/lux-ds-pms';
import { AuthProvider } from '@gemini/fe-utils';
import './App.scss';
import ExamImportPage from '@pages/ExamImportPage/ExamImportPage';

function App() {
  useEnv();

  return (
    <>
      <AuthProvider>
        <ExamImportPage />
      </AuthProvider>
    </>
  );
}
export default App;
